import styled from "styled-components";
import {baseColors} from "../../../../themes/definitions/mrgreen/base-colors";

export const JackpotBetWidgetGradientBackgroundTextMRGBox = styled.div`
  background: ${baseColors.base01Dark};
  box-shadow: 0px 2px 8px 0px ${baseColors.base01Contrast}, 0px -1px 10px 0px ${baseColors.base02} inset, 0px 0px 2px 0px ${baseColors.base02} inset;
  width: fit-content;
  border-radius: 30px;
  padding: 4px 12px;
  align-self: center;
  font-size: 3.2rem;
  font-weight: 700;
  line-height: 38.4px;
  letter-spacing: -0.5px;
  text-align: center;
`;
